module.exports = __webpack_public_path__ + "img/tx@3x.5bdb6129.png";